import {Component, EventEmitter, Input, OnChanges, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import { CheckboxComponent, SearchBarComponent } from '@healthcatalyst/cashmere';

@Component({
    selector: 'filter-popover',
    templateUrl: './filter-popover.component.html',
    styleUrls: ['./filter-popover.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FilterPopoverComponent implements OnChanges {
    private filterArray: string[] = [];
    totalFilterCount: number;
    filterCount: number;
    public disableSelectAll = false;
    public disableSelectNone = true;

    @ViewChildren(CheckboxComponent) checkboxList: QueryList<CheckboxComponent>;

    @ViewChild(SearchBarComponent) searchBar: SearchBarComponent; 

    @Input()
    filterData: string[];

    @Input()
    setVals: string[];

    @Output() 
    filterChecked: EventEmitter<string[]> = new EventEmitter<string[]>();

    @Output() 
    close: EventEmitter<void> = new EventEmitter<void>();

    ngOnChanges() {
        this.filterData && (this.filterCount = this.filterData.length);
        this.setVals && (this.filterArray = this.setVals);
        this.searchBar && this.searchBar.clear();

        //reset the select all/none buttons based on previously set values
        if(this.setVals.length > 0) {
            if(this.setVals.length === this.filterData.length) {
                this.disableSelectAll = true;
                this.disableSelectNone = false;
            } else if(this.setVals.length >= 1){
                this.disableSelectAll = false;
                this.disableSelectNone = false;
            } 
        } else if (this.filterArray.length === 0) {
            this.disableSelectAll = false;
            this.disableSelectNone = true;
        } 
    }

    checkEvent(filterVal: string) {
        if (!this.filterArray.includes(filterVal)) {
            this.filterArray.push(filterVal);
        } else {
            const index = this.filterArray.indexOf(filterVal);
            if (index > -1) {
                this.filterArray.splice(index, 1);
            }
        }

        // disable/enable select all/none buttons based on checked boxes
        if(this.filterArray.length === this.checkboxList.length) {
            this.disableSelectAll = true;
            this.disableSelectNone = false;
        } else if(this.filterArray.length >= 1){
            this.disableSelectAll = false;
            this.disableSelectNone = false;
        } else {
            this.disableSelectNone = true;
        }

        this.filterChecked.emit(this.filterArray);
    }

    textFilter(filter: string) {
        let filteredItems = [];

        let checkList = document.getElementsByTagName('hc-checkbox');
        
        for (let i = 0; i < this.filterData.length; i++) {
            if(this.filterData[i].toString().toLowerCase().includes(filter.toLowerCase().trim())){
                filteredItems.push(this.filterData[i]);
                checkList[i].removeAttribute('class');
            } else
                checkList[i].setAttribute('class', 'hidden');
        }
        
        this.filterCount = this.filterData.length - document.getElementsByClassName('hidden').length;
    }

    selectAll() {
        this.disableSelectAll = true;
        this.disableSelectNone = false;

        this.checkboxList.forEach(checkbox => {
            checkbox.checked = true;
        });

        this.filterArray = [];
        
        for (let i = 0; i < this.filterData.length; i++) {
            this.filterArray.push(this.filterData[i]);            
        }
        this.filterChecked.emit(this.filterArray);
    }

    selectNone() {
        this.disableSelectNone = true;
        this.disableSelectAll = false;

        this.checkboxList.forEach(checkbox => {
            checkbox.checked = false;
        });
        
        this.filterArray = [];
        this.filterChecked.emit(this.filterArray);
    }
}
